import { useEffect, useRef, useState } from "react";
import StudentModel from "../../api/models/StudentModel";
import TutorModel from "../../api/models/TutorModel";
import { classNames } from "../../helpers";
import { useTranslation } from "react-i18next";

export default function DropDownFilter({
  list,
  setStatusFilter,
  statusFilter,
}: {
  list: (StudentModel | TutorModel | any)[];
  setStatusFilter: any;
  statusFilter: string;
}) {
  const LocalBasePath = "page.supervisor.sessions";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const [isOpen, setIsOpen] = useState(false);

  // Ref to handle click outside
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const clearOptions = () => {
    setIsOpen((prev) => !prev);
    setStatusFilter("");
  };

  return (
    <div className="relative inline-block text-left">
      {/* Dropdown button */}
      <span className="mt-2 content-box inline-block" onClick={toggleDropdown}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-6 h-6 text-gray-600 cursor-pointer p-1"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3 4h18l-7 10v6l-4-2v-4L3 4z"
          />
        </svg>
      </span>

      {/* Dropdown menu */}
      {isOpen && (
        <div
          ref={dropdownRef}
          className="z-10 right-0 translate-x-1/2 absolute bg-white divide-y divide-gray-100 rounded-lg shadow w-44 "
        >
          <ul className="py-2 text-sm text-gray-700 text-start">
            {list.map((item, index) => (
              <li key={index}>
                <a
                  href={item.id}
                  onClick={(e) => {
                    e.preventDefault(); // Prevent the default link behavior
                    setStatusFilter(item.value); // Call the onItemClick handler
                    toggleDropdown();
                  }}
                  className={classNames(
                    "block px-4 py-2 hover:bg-gray-100 ",
                    statusFilter == item.value && "text-white bg-brandblue-300"
                  )}
                >
                  {t(item.id)}
                </a>
              </li>
            ))}
          </ul>
          <button
            onClick={clearOptions}
            className="flex items-center p-3 text-sm font-medium text-gray-700 rounded-b-lg hover:bg-gray-100 "
          >
            {t("clear")}
          </button>
        </div>
      )}
    </div>
  );
}
